module.exports = __webpack_public_path__ + "20473158ff709f375c5b2121b8b561ad.pdf";